import React, { PureComponent, PropTypes } from 'react';
import BookInput from 'components/BookInput/BookInput';
import BookCheckbox from 'components/BookCheckbox/BookCheckbox';

import InlineSVG from 'svg-inline-react';
import alertIcon from './images/bell.svg';

import './EmailSignUp.scss';

export default class EmailSignUp extends PureComponent {

  static propTypes = {
    email: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    onEmailBlur: PropTypes.func,
    onNameBlur: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    setEmailField: PropTypes.func.isRequired,
    setNameField: PropTypes.func.isRequired,
    setSubscribe: PropTypes.func.isRequired,
    subscribe: PropTypes.bool.isRequired,
    validation: PropTypes.object.isRequired,
    displayDisclaimer: PropTypes.bool,
  };

  static defaultProps = {
    displayDisclaimer: false,
  }

  render() {
    const {
      email,
      formName,
      fullName,
      onEmailBlur,
      onNameBlur,
      onSubmit,
      setEmailField,
      setNameField,
      setSubscribe,
      subscribe,
      validation,
      displayDisclaimer,
    } = this.props;

    return (<div className="email-sign-up">
      <form action="POST" onSubmit={onSubmit}>
        <BookInput
          autoCapitalize="words"
          data={{
            fieldKey: 'fullName',
          }}
          formName={formName}
          isValid={validation.confirmName.isValid(fullName)}
          label="Name:"
          message={validation.confirmName.message}
          onFieldBlur={onNameBlur}
          onFieldChange={setNameField}
          value={fullName}
        />
        <BookInput
          data={{
            fieldKey: 'email',
          }}
          formName={formName}
          isValid={validation.confirmEmail.isValid(email)}
          label="Your Email:"
          message={validation.confirmEmail.message}
          onFieldBlur={onEmailBlur}
          onFieldChange={setEmailField}
          type="email"
          value={email}
        />
        <BookCheckbox
          label=" Sign up to our offer emails"
          onFieldChange={setSubscribe}
          checked={subscribe}
        />
        <button type="submit" className="email-sign-up__submit-button">
          <InlineSVG src={alertIcon} className="email-sign-up__submit-button__icon" />
          Sign up for Price Alerts
        </button>
        {displayDisclaimer && (
          <p className="email-sign-up__disclaimer">Please note that elements of your holiday may change over the the next 7 days. As a result it may be difficult to track an exact like-for-like holiday price. Please make sure when booking that all details match your original requirements.</p>
        )}
      </form>
    </div>);
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/EmailSignUp/EmailSignUp.jsx
 **/